<div
  [ngClass]="{ 'd-block': lang === 'en', 'd-none': lang !== 'en' }"
  class="trustpilot-widget"
  data-locale="en-GB"
  data-template-id="54ad5defc6454f065c28af8b"
  data-businessunit-id="5e559cdc1d562000013d923b"
  data-style-height="240px"
  data-style-width="100%"
  data-theme="light"
  data-stars="4,5"
  data-review-languages="en"
>
  <a
    href="https://uk.trustpilot.com/review/airportr.com"
    target="_blank"
    rel="noopener"
    >Trustpilot</a
  >
</div>
<div
  [ngClass]="{ 'd-block': lang === 'fr', 'd-none': lang !== 'fr' }"
  class="trustpilot-widget"
  data-locale="en-GB"
  data-template-id="54ad5defc6454f065c28af8b"
  data-businessunit-id="5e559cdc1d562000013d923b"
  data-style-height="240px"
  data-style-width="100%"
  data-theme="light"
  data-stars="4,5"
  data-review-languages="fr"
>
  <a
    href="https://uk.trustpilot.com/review/airportr.com"
    target="_blank"
    rel="noopener"
    >Trustpilot</a
  >
</div>
<div
  [ngClass]="{ 'd-block': lang === 'de', 'd-none': lang !== 'de' }"
  class="trustpilot-widget"
  data-locale="en-GB"
  data-template-id="54ad5defc6454f065c28af8b"
  data-businessunit-id="5e559cdc1d562000013d923b"
  data-style-height="240px"
  data-style-width="100%"
  data-theme="light"
  data-stars="4,5"
  data-review-languages="de"
>
  <a
    href="https://uk.trustpilot.com/review/airportr.com"
    target="_blank"
    rel="noopener"
    >Trustpilot</a
  >
</div>

<div
  [ngClass]="{ 'd-block': lang === 'it', 'd-none': lang !== 'it' }"
  class="trustpilot-widget"
  data-locale="en-GB"
  data-template-id="54ad5defc6454f065c28af8b"
  data-businessunit-id="5e559cdc1d562000013d923b"
  data-style-height="240px"
  data-style-width="100%"
  data-theme="light"
  data-stars="4,5"
  data-review-languages="it"
>
  <a
    href="https://uk.trustpilot.com/review/airportr.com"
    target="_blank"
    rel="noopener"
    >Trustpilot</a
  >
</div>
